module.exports = __webpack_public_path__ + "static/media/benzodiazepinesActive.f7dc2584.svg";